// extracted by mini-css-extract-plugin
export var sliderRange = "_ra-2";
export var sliderRoot = "_ra-0";
export var sliderThumb = "_ra-3";
export var sliderTrack = "_ra-1";